export default __webpack_public_path__ + "6c6c5392f9da039cf4be1deec2c1136a.svg";